<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();

function showUsers() {
  router.push('/users');
}
function showCommunity() {
  router.push('/users/communities');
}
function showOrgs() {
  router.push('/users/organizations');
}

function getPage(path: string): string {
  switch (path) {
    case '/users':
      return 'List';
    case '/users/communities':
      return 'Communities';
    case '/users/organizations':
      return 'Organizations';
  }
  return '';
}
</script>
<template>
  <v-app-bar app>
    <v-breadcrumbs :items="['Users', getPage(route.path)]" />
    <v-btn flat v-if="route.path !== '/users'" color="info" @click="showUsers"
      >List</v-btn
    >
    <v-btn
      flat
      v-if="route.path !== '/users/communities'"
      color="info"
      @click="showCommunity"
      >Communities</v-btn
    >
    <v-btn
      flat
      v-if="route.path !== '/users/organizations'"
      color="info"
      @click="showOrgs"
      >Organizations</v-btn
    >
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
